// extracted by mini-css-extract-plugin
export default {"root":"TabNav_root__ivfMt","tab":"TabNav_tab__9FkQk","link":"TabNav_link__8m6VE textSmall","selectedLink":"TabNav_selectedLink__ZVw0L","disabled":"TabNav_disabled__uSGs3"};